import {
  ErrorModal,
  HelmetDexteel,
  ShiftDayNavigatorControl,
  useShiftNavigator,
} from "@dexteel/mesf-core";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useDelaysByShiftQuery } from "../hooks/queries";
import { DelaysManagerTable } from "./components/table/DelaysManagerTable";

const assetTitles: { [key: number]: string } = {
  11: "EAF Delays Manager",
  12: "LMF Delays Manager",
  13: "Caster Delays Manager",
};

export const DelaysManagerPage = () => {
  const { shiftInfo, getShiftDataFromAPI } = useShiftNavigator();
  const { shiftId } = useParams();
  const [searchParams] = useSearchParams();

  const [showMicroDelays, setShowMicroDelays] = useState(false);
  const [currentAssetId, setCurrentAssetId] = useState<number | null>(null);
  const [error, setError] = useState("");

  const assetIdParam = Number(searchParams.get("assetId")) || null;
  const delayIdParam = Number(searchParams.get("delayId")) || null;

  useEffect(() => {
    if (assetIdParam && assetIdParam !== currentAssetId) {
      setCurrentAssetId(assetIdParam);
    }
  }, [assetIdParam]);

  useEffect(() => {
    getShiftDataFromAPI(null, shiftId ? Number(shiftId) : 0);
  }, [shiftId]);

  const effectiveAssetId = currentAssetId ?? assetIdParam;

  const { data: delays = [], isLoading } = useDelaysByShiftQuery(
    shiftInfo?.CurrentShiftId ?? 0,
    effectiveAssetId,
    showMicroDelays,
    (err) => setError(err.message),
  );

  const assetTitle = currentAssetId
    ? assetTitles[currentAssetId]
    : "Delays Manager";

  return (
    <>
      <HelmetDexteel
        title={`${shiftInfo?.CurrentStart.toLocaleDateString()} - ${assetTitle}`}
      />
      <Grid container spacing={2} sx={{ p: 2 }}>
        <Grid item xs={12}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            {assetTitle}
          </Typography>
        </Grid>
        <Grid item md={12} xs={12}>
          <Paper sx={{ p: 2 }} elevation={2}>
            <Grid container alignItems="center">
              <Grid item sx={{ width: "fit-content" }}>
                <ShiftDayNavigatorControl
                  preventInit
                  withPaper={false}
                  margin="0"
                />
              </Grid>
              <Grid item sx={{ width: "fit-content", ml: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={showMicroDelays}
                      color="primary"
                      onChange={(event) =>
                        setShowMicroDelays(event.target.checked)
                      }
                    />
                  }
                  label="Microdelays"
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <DelaysManagerTable
            isLoading={isLoading}
            delays={delays}
            assetId={effectiveAssetId ?? undefined}
            delayId={delayIdParam ?? undefined}
          />
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
